import { atom } from "jotai";

export const paperworkBackRouteAtom = atom<string | undefined>(undefined);
